import { Card, Button, Spin, Input, Pagination } from "antd";
import {
  FileTextOutlined,
  DownloadOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import { CERTIFICATE_LIST } from "../../apis/apis";
import { useEffect, useState, useCallback } from "react";
import debounce from "lodash/debounce";
import CulsightPageLoader from "../../components/CulsightPageLoader";

const { Search } = Input;

function Certificate() {
  const [loading, setLoading] = useState(true);
  const [certificate, set_certificate] = useState([]);

  const [current_page, set_current_page] = useState(1);
  const [total_pages, set_total_pages] = useState(1);
  const [total_certificates, set_total_certificates] = useState(0);

  const [pagination_loader, set_pagination_loader] = useState(false);
  const [search_query_title, set_search_query_title] = useState("");

  // ✅ API CALL FUNCTION
  const LIST_API = async (page = 1, search = "") => {
    try {
      if (page === 1) setLoading(true);
      else set_pagination_loader(true);

      const FORM_DATA = new FormData();
      FORM_DATA.append("page", page);

      // ✅ search by title
      if (search) {
        FORM_DATA.append("course_name", search);
      }

      const API_CALL = await CERTIFICATE_LIST(FORM_DATA);

      if (API_CALL?.data?.status) {
        set_certificate(API_CALL.data.data || []);
        set_current_page(API_CALL.data.current_page);
        set_total_pages(API_CALL.data.total_pages);
        set_total_certificates(API_CALL.data.total_certificates);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
      set_pagination_loader(false);
    }
  };

  // ✅ INITIAL LOAD
  useEffect(() => {
    LIST_API();
  }, []);

  // ✅ PAGINATION
  const pagination_on_change = (page) => {
    LIST_API(page, search_query_title);
  };

  // ✅ SEARCH (Debounced)
  const handleSearch = useCallback(
    debounce((value) => {
      set_search_query_title(value);
      LIST_API(1, value); // reset to page 1
    }, 500),
    []
  );

  // ✅ DOWNLOAD
  const handleDownload = (url) => {
    if (!url) return;

    const printWindow = window.open(url, "_blank");
    if (printWindow) {
      printWindow.onload = () => {
        printWindow.print();
      };
    }
  };

  return (
    <div className="lms-body">

      <Card>
        <h2>My Certificates</h2>

        {/* ✅ SEARCH BAR */}
        <Search
          placeholder="Search by course name"
          onChange={(e) => handleSearch(e.target.value)}
          style={{ width: 300, marginBottom: 20 }}
          allowClear
        />

        {loading ? (
          <div style={{ textAlign: "center", marginTop: 50 }}>
            <CulsightPageLoader />
          </div>
        ) : (
          <>
            <div className="card-container">
              {certificate.length > 0 ? (
                certificate.map((cert, index) => (
                  <Card
                    key={index}
                    className="certificate-card"
                    bordered={false}
                    bodyStyle={{ padding: 0 }}
                    hoverable
                  >
                    <div className="card-top">
                      <FileTextOutlined className="icon" />
                      <h3>{cert.course_name}</h3>
                      <p>Certificate of Completion</p>
                    </div>

                    <div className="card-bottom">
                      <p>
                        <CalendarOutlined /> Issued:{" "}
                        {cert.issued_date
                          ? new Date(cert.issued_date).toLocaleDateString()
                          : "N/A"}
                      </p>

                      <p className="single-line-ellipsis">
                        Certificate #: {cert.certificate_number || "N/A"}
                      </p>

                      {cert.certificate && (
                        <Button
                          type="primary"
                          icon={<DownloadOutlined />}
                          block
                          onClick={() => handleDownload(cert.certificate)}
                        >
                          Download PDF
                        </Button>
                      )}
                    </div>
                  </Card>
                ))
              ) : (
                <p>No certificate found.</p>
              )}
            </div>

            {/* ✅ PAGINATION */}
            <div style={{ textAlign: "center", marginTop: 20, float: "right" }}>
              <Pagination
                current={current_page}
                total={total_certificates}
                pageSize={9}
                onChange={pagination_on_change}
                showSizeChanger={false}
              />
            </div>
          </>
        )}
      </Card>

    </div>
  );
}

export default Certificate;